import styled from 'styled-components'

export const Content = styled.div`
  padding-top: 24px;
  height: 100%;
`
